/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

const form = {
  formId: "sign-up-form",
  formField: {
    email: {
      name: "email",
      label: "Email",
      type: "text",
      errorMsg: "Email is required.",
    },
    mobile: {
      name: "mobile",
      label: "Mobile",
      type: "text",
      errorMsg: "Mobile is required.",
    },
    recaptcha: {
      name: "recaptcha",
      label: "Recaptcha",
      type: "text",
      errorMsg: "Recaptcha verification is required.",
    },
    mobile_otp: {
      name: "mobile_otp",
      label: "Mobile OTP",
      type: "text",
      errorMsg: "Mobile OTP is required.",
    },
    email_otp: {
      name: "email_otp",
      label: "E-mail OTP",
      type: "text",
      errorMsg: "E-mail OTP is required.",
    }
  }
};

export default form;
